import DashboardContext from '@/context/DashboardContext.jsx';

const DashboardProvider = ({ value, children }) => {
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
};

export default DashboardProvider;
